import { render } from "./WinnersListIndividual.vue?vue&type=template&id=3e5e67bb&scoped=true"
import script from "./WinnersListIndividual.vue?vue&type=script&lang=js"
export * from "./WinnersListIndividual.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3e5e67bb"

export default script